import { Grid, Box } from "@mui/material";
import { LayeredMediaEntity } from "../../../models/OrderManagement";

type PerspectiveImageProps = {
    data:LayeredMediaEntity[]
}


const PerspectiveImage = ({ data }: PerspectiveImageProps) => {
    const topPerspective:LayeredMediaEntity[] = data.filter((item:LayeredMediaEntity)=>item.perspectiveName === "Top");
    const sidePerspective:LayeredMediaEntity[] = data.filter((item:LayeredMediaEntity)=>item.perspectiveName === "Side");

    return (
        data && (
            <Grid mt={1.5} container className="image-perspective-container" justifyContent="space-around">
                <Grid item xs={6} >
                    <Box className="layered-media-container">
                        {
                            topPerspective.map((image:LayeredMediaEntity, index:number)=><Box key={index} className="image-wrapper top"><img src={image?.mediaUrl}/></Box>)
                        }
                    </Box>
                </Grid>
                <Grid item xs={6} >
                <Box className="layered-media-container">
                        {
                            sidePerspective.map((image:LayeredMediaEntity , index:number)=><Box key={index} className="image-wrapper side" ><img src={image?.mediaUrl}/></Box>)
                        }
                    </Box>
                </Grid>
            </Grid>
        )
    )
}

export default PerspectiveImage